import api from './Api'

const route = '/partner-group'

export default {
  index: params => api().get(`${route}`, { params }),

  // Ver un grupo específico
  view(id, params) {
    return api().get(`${route}/${id}`, { params })
  },

  // Crear un nuevo grupo de partners
  create(data) {
    return api().post(route, data)
  },

  // Actualizar un grupo de partners
  update(id, data) {
    return api().put(`${route}/${id}`, data)
  },

  // Eliminar un grupo de partners
  delete(id) {
    return api().delete(`${route}/${id}`)
  },

  // Obtener usuarios del grupo
  getUsers(id, params) {
    return api().get(`${route}/${id}/users`, { params })
  }
}
